/**
 * Shared enter/exit timing for entity tile image reveal and equip-slot art.
 * Keep in lockstep with {@link EntityTileImage} load animation.
 */
export const ENTITY_TILE_IMAGE_PLACEHOLDER_OUT_MS = 200;
export const ENTITY_TILE_IMAGE_IN_DELAY_MS = 90;
export const ENTITY_TILE_IMAGE_IN_MS = 220;
export const ENTITY_TILE_IMAGE_IN_OVERSCALE = 1.08;
